import { action } from 'typesafe-actions';

export const RESET = 'RESET';

export interface Reset {
  type: typeof RESET;
}

export const resetStore = () => action(RESET);
